import React from 'react'
import { WithTemplate } from '@morningtrain/react-app'
import { Form, TriggerPipelineOnFormSubmit } from '@morningtrain/react-resources'
import * as Fields from 'support/fields'
import { Fieldset } from 'layouts'
import { useRouter } from '@morningtrain/react-navigation'
import { Pipeline } from '@morningtrain/react-helpers'
import RedirectOnPipe from 'support/pipelines/pipes/RedirectOnPipe'

export default function AuthTablet (props) {
  const router = useRouter()

  return (
    <WithTemplate template='Auth'>
      <Form route='auth.tablet.authorize_tablet'>
        <Pipeline>
          <TriggerPipelineOnFormSubmit />
          <RedirectOnPipe routeName={router.redirectOnLogoutRoute} />
        </Pipeline>
        <div className='form-content login'>
          <Fieldset>
            <Fields.Input name='device_code' label='Device code' required autoFocus />
          </Fieldset>
        </div>

        <div className='mt-6'>
          <span className='block w-full rounded-md shadow-sm'>
            <button
              type='submit'
              className='w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-500 hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition duration-150 ease-in-out'
            >
              Authorize
            </button>
          </span>
        </div>
      </Form>
    </WithTemplate>
  )
}
